import TabsProps from "!!extract-react-types-loader!../../../../../../packages/design-system/tabs/src/components/tabs";
import TabProps from "!!extract-react-types-loader!../../../../../../packages/design-system/tabs/src/components/tab";
import TabPanelProps from "!!extract-react-types-loader!../../../../../../packages/design-system/tabs/src/components/tab-panel";
import TabAttributesType from "!!extract-react-types-loader!../../../../../../packages/design-system/tabs/extract-react-types/tab-attributes";
import TabPanelAttributesType from "!!extract-react-types-loader!../../../../../../packages/design-system/tabs/extract-react-types/tab-panel-attributes";
import * as React from 'react';
export default {
  TabsProps,
  TabProps,
  TabPanelProps,
  TabAttributesType,
  TabPanelAttributesType,
  React
};